










import Vue from "vue";
import { useCurrencyInput } from "vue-currency-input";
import { watch } from "@vue/composition-api";

export default Vue.extend({
  name: "CurrencyInput",
  props: {
    value: Number,
    placeholder: String,
    disabled: Boolean,
  },
  setup(props) {
    const { inputRef, setValue } = useCurrencyInput({ currency: "EUR" });

    watch(
      () => props.value,
      (v) => {
        setValue(v as number);
      },
    );

    return { inputRef, setValue };
  },
});
